import React, {Fragment, useContext, useEffect, useState} from 'react';
import {EuiBadge, EuiButton, EuiEmptyPrompt, EuiInMemoryTable, EuiPanel, EuiSpacer, EuiText} from "@elastic/eui";
import {NavLink, useHistory} from "react-router-dom";
import {Order} from "../../../app/models/order";
import { Ticket } from '../../../app/models/Ticket';
import OrdersErrorModal from "../../orders/form/modal-order-no-balance";
import {Store} from "../../../app/stores/store-root";
import MessageModal from "../../../app/common/message-modal";
import {observer} from "mobx-react-lite";
import {SearchFilterConfig} from "@elastic/eui/src/components/search_bar/search_filters";
import {EuiSearchBarProps} from "@elastic/eui/src/components/search_bar/search_bar";

type ListSupportTicketsProps={
    items : Ticket[]
}

const ListSupportTickets = ({items}:ListSupportTicketsProps) => {

    const store = useContext(Store);
    const history = useHistory();

    const onEdit=(ticket : Ticket)=>{
        if(ticket.Status==="1" || ticket.Status==="2")
        {
            store.Modal.closeModal();
            store.Modal.openModal(<MessageModal message={'This ticket cannot be edited.'} success={false}/>);
        }else{
            history.push(`/tickets/edit/${ticket.Id}`)
        }
    }

    const onCancel=(ticket : Ticket)=>{
        if(ticket.Status==="1" || ticket.Status==="2")
        {
            store.Modal.closeModal();
            store.Modal.openModal(<MessageModal message={'This ticket cannot be cancelled.'} success={false}/>);
        }
        else{
            store.SupportTickets.CancelTicket(ticket).then(() => {
                console.log('Support ticket cancelled');
                history.push('/');
            }).catch(() => {
                store.Modal.closeModal();
                store.Modal.openModal(<MessageModal message={'Error cancelling this ticket'} success={false}/>);
            }).finally(() => {
            })
        }
    }

    const actions: any[] = [
        {
            name: 'Cancel',
            description: 'Close this support ticket',
            icon: 'cross',
            type: 'icon',
            onClick: onCancel ,
        },
        {
            name: 'Edit',
            description: 'Edit this support ticket',
            icon: 'indexEdit',
            type: 'icon',
            onClick: onEdit ,
        }
    ]

    const fields = [
        {
            field: 'Reference',
            name: 'Reference',
            sortable: true,
            truncateText: true,
            render: (reference: string) => {
                return (<NavLink to={`orders/edit/${reference}`}>
                    {reference}
                </NavLink>)
            }
        },
        {
            field: 'TicketType',
            name: 'Type',
            truncateText: true,
            render: (value: any, item: Ticket) => {
                if (value==='0')
                    return "Correction/Change";
                if(value==='1')
                    return "Cancel";
                if(value==='2')
                    return "Unspecified";
            }

        },
        {
            field: 'Note',
            name: 'Note',

        },
        {
            field: 'Status',
            name: 'Status',
            truncateText: true,
            render: (type: any) => {
                if (type === "1")
                    return <EuiBadge color="primary">Closed</EuiBadge>
                if (type === "0")
                    return <EuiBadge color="warning">Open</EuiBadge>
                if (type === "2")
                    return <EuiBadge color="#AAA">Cancelled</EuiBadge>
            }

        },

        {
            field: 'CreatedAt',
            name: 'Created At',
            sortable: true,

        },

        {
            name:'Actions',
            actions
        }
    ]



    const [message, setMessage] = useState(
        <EuiEmptyPrompt
            iconType="editorStrike"
            title={<h2>You have no support tickets</h2>}
            body={
                <Fragment>
                    <p>

                    </p>

                </Fragment>
            }
            actions={
                <EuiButton color="primary" fill>
                    Load orders
                </EuiButton>
            }
        />
    );

    const searchFilters: SearchFilterConfig[] = [
        {
            type: 'field_value_toggle_group',
            field: 'Status',
            items: [
                {
                    value: 0,
                    name: 'Open'
                },
                {
                    value: 1,
                    name: 'Closed'
                },
                {
                    value: 2,
                    name: 'Cancelled'
                }
            ]
        },
    ]

    const searchSettings: EuiSearchBarProps = {
        box: {
            incremental: true,
            schema: true,
            placeholder: ''
        },
        filters: searchFilters
    }

    return (
        <EuiPanel paddingSize="l" hasShadow>
            <EuiText>
                <h3>My Support Tickets</h3>
                <p>
                    This section lists all money transfer orders you have created. You can filter and sort your records by status, user name, and pickup office
                </p>
            </EuiText>
            <EuiSpacer size={"xxl"}/>
            <EuiInMemoryTable
                items={items}
                itemId="Id"
                hasActions={true}
                columns={fields}
                pagination={true}
                //selection={selectionValue}
                isSelectable={true}
                search={searchSettings}
                sorting={true}
                message={message}


            />
        </EuiPanel>

    );
};

export default observer(ListSupportTickets);
